import { Facebook, Instagram, Linkedin, Mail } from "lucide-react";

export const Footer: React.FC = () => {
  return (
    <div className="pt-10 px-4 lg:px-0 flex justify-center w-full bg-primary">
      <div className=" lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl lg:mx-0 w-full">
        {/* Container Principal */}
        <div className="flex lg:space-x-6 items-center md:items-start py-6">
          <img
            src={require("../../assets/prof-historia.png")}
            alt="Logo Site"
            className="h-14 mb-4"
          />
          <img
            src={require("../../assets/logo.png")}
            alt="Logo URCA"
            className="h-14 mb-4"
          />
          <img
            src={require("../../assets/CNP_logo.png")}
            alt="Logo CNPQ"
            className="h-14 mb-4"
          />
        </div>

        {/* Conteúdo do Footer */}
        <div className="grid grid-cols-1 md:grid-cols-4 text-center">
          {/* Coluna 1 */}
          <div className="flex flex-col col-span-1 text-white space-y-2 md:text-left">
            <p className="text-sm">Prof Marcos Manoel Silva Severiano</p>
            <p className="text-sm">Universidade Regional do Cariri - URCA</p>
          </div>

          {/* Coluna 2 */}
          <ul className="flex flex-col col-span-1 items-center md:items-start text-white text-sm space-y-2 md:text-center mt-6 md:mt-0">
            <li className=" py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#habilidades">Competências e Habilidades</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className=" py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#microdata">Análise de Microdados</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className=" py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#taxonomia">Taxonomia</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
          </ul>

          <ul className="flex flex-col col-span-1 items-center md:items-start text-white text-sm space-y-2 md:text-center">
            <li className=" py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#interesses">Estados</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className=" py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#estatisticas">Estatísticas</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className=" py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#indications">Indicações</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
          </ul>

          {/* Coluna 3 */}
          <div className="flex flex-row items-center justify-center md:items-start md:justify-start space-x-4 col-span-1 text-white text-sm md:text-right">
            <div className="size-10 p-2 shadow-md cursor-pointer transition-transform duration-300 hover:text-primary-red">
              <Linkedin className="size-10" />
            </div>

            <div className="size-10 p-2 shadow-md cursor-pointer transition-transform duration-300 hover:text-primary-red">
              <Instagram className="size-10" />
            </div>

            <div className="size-10 p-2 shadow-md cursor-pointer transition-transform duration-300 hover:text-primary-red">
              <Mail className="size-10" />
            </div>
          </div>
        </div>
        <span className="flex items-center justify-center pt-8 text-xs text-white">
          © 2025 Marcos. Todos os direitos reservados. Desenvolvido por
          <a href="https://brilhanti.com.br/">BrilhanTI</a>
        </span>
      </div>
    </div>
  );
};
